import { appPaths } from "@clockwise/web-commons/src/constants/route.constants";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { useRouter } from "found";
import { isEmpty } from "lodash";
import toast from "react-hot-toast";
import { getActiveEventKeyFromRoute } from "../planner-state-persistance/util/getActiveEventKeyFromRoute";

export const usePlannerToAIRedirect = () => {
  const track = useTracking();
  const { match } = useRouter();

  const { hash } = match.location;

  const idFromRoute = getActiveEventKeyFromRoute(match);
  const hasEventId = idFromRoute && "externalEventId" in idFromRoute && idFromRoute.externalEventId;
  const eventQueryStringParam = hasEventId
    ? `?eid=${idFromRoute.externalEventId}&fromPlanner=true`
    : "?fromPlanner=true";

  const redirectUrl = `${appPaths.ai}${eventQueryStringParam}${hash}`;

  track(TrackingEvents.PLANNER.REDIRECT, { redirectUrl });
  redirectTo(redirectUrl);
};

export const useRedirectedFromPlanner = () => {
  const { match, router } = useRouter();

  const searchParams = new URLSearchParams(match.location.search);
  const fromPlanner = searchParams.get("fromPlanner");

  if (fromPlanner) {
    // Show a toast message to inform the user that the event was added to their calendar
    toast.success("Prism is the new Planner", {
      duration: 5000,
      position: "top-center",
    });

    // Remove the eventid parameter from the URL
    searchParams.delete("fromPlanner");
    const newLocation = {
      ...match.location,
      search: searchParams.toString(),
    };
    router.push(
      `${newLocation.pathname}${isEmpty(newLocation.search) ? "" : "?"}${newLocation.search}${
        newLocation.hash
      }`,
    );
  }
};

const redirectTo = (url: string) => {
  window.location.href = url;
};
